import {TicketEntity} from "@dropDesk/domain/entities/ticket/ticket.entity";
import {injectable} from "inversify";
import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import {Observable} from "rxjs";
import {ExportDataEntity} from "@dropDesk/domain/entities/export_data/export_data_entity";
import {TicketConfig} from "@dropDesk/domain/entities/ticket/ticket_config";
import {CancelTokenSource} from "axios";
import {BackupData} from "@dropDesk/domain/entities/ticket/backup/backup_data";

@injectable()
export abstract class TicketRepository {

    public abstract set(ticket: TicketEntity): Promise<TicketEntity>;

    public abstract findByPK(id: string, listMessages: boolean, cancelTokenSource?: CancelTokenSource): Promise<TicketEntity>;

    public abstract listTicketsSubscription(
        searchParam: string,
        page: number,
        limit: number,
        listOnlyDeleted: boolean,
        status: string | null,
        priority: string | null,
        listOnlySectorEmpty: boolean,
        id: string,
        handleDisconnect: (temporary: boolean) => void,
        getLastUpdates: () => void,
        useSocket: boolean
    ): Observable<ListPaginationEntity<TicketEntity> | null>;


    public abstract restore(tickets: TicketEntity[]): Promise<void>;

    public abstract delete(tickets: TicketEntity[]): Promise<void>;

    public abstract transfer(idTicket: string, newSectorId: string, newAttendantId?: string): Promise<TicketEntity>;

    public abstract changeTimeSpent(idTicket: string, timeSpent: number): Promise<TicketEntity>;

    public abstract changePriority(idTicket: string, priority: string): Promise<TicketEntity>;

    public abstract changeDateDue(idTicket: string, dateDue: string): Promise<TicketEntity>;

    public abstract changeProblemDescription(idTicket: string, description: string): Promise<TicketEntity>;

    public abstract cancel(idTicket: string, cancelDescription?: string): Promise<TicketEntity>;

    public abstract close(idTicket: string, closeDescription?: string): Promise<TicketEntity>;

    public abstract changeResolution(idTicket: string, closeDescription: string): Promise<TicketEntity>;

    public abstract linkAttendant(idTicket: string): Promise<TicketEntity>;

    public abstract exportSubscription(
        id: string,
        handleDisconnect: (temporary: boolean) => void,
        getLastUpdates: () => void,
        useSocket: boolean
    ): Observable<ExportDataEntity | null>;

    public abstract exportPdf(idTicket: string): Promise<void>;

    public abstract export(
        period: { startDate: string, endDate: string },
        idUser: string | null,
        idSector: string | null,
        idClient: string | null,
        id?: string,
    ): Promise<ExportDataEntity>;

    public abstract getConfigs(): Promise<TicketConfig[]>;

    public abstract list(
        searchParam: string,
        page: number,
        limit: number,
        listOnlyDeleted: boolean,
        status: string | null,
        priority: string | null,
        listOnlySectorEmpty: boolean,
        cancelTokenSource?: CancelTokenSource
    ): Promise<ListPaginationEntity<TicketEntity>>;

    public abstract listBackups(
        searchParam: string,
        page: number,
        limit: number,
    ): Promise<ListPaginationEntity<BackupData>>;

    public abstract startBackup(): Promise<BackupData>;
}
